import { generateQueryString } from '../../../common/base/report/report-util';

export const queryStringCalc = ({
  reportConfig,
  criteria,
  token,
  devSetting,
}) => {
  const params = [];

  if (reportConfig) {
    if (reportConfig.filters.resaleYear) {
      if (criteria.resaleYear) {
        params.push(`resaleYear=${criteria.resaleYear}`);
      }
    }
    if (reportConfig.filters.printDetails) {
      params.push(`printDetails=${criteria.printDetails}`);
    }
    if (reportConfig.filters.printOrder) {
      params.push(`printOrder=${criteria.printOrder}`);
    }
    if (reportConfig.filters.sortOrder) {
      params.push(`sortOrder=${criteria.sortOrder}`);
    }
    if (reportConfig.filters.sortBy) {
      params.push(`sortOrder=${criteria.sortOrder}`);
    }
  }

  if (token) {
    params.push(`token=${token}`);
  }

  /* For testcafe */
  if (devSetting && devSetting.isTestEnvironment) {
    params.push('isTestCafe=1');
  }

  return generateQueryString(params);
};

export const resaleReportList = () => {
  const item = [{
    id: 1,
    description: 'County Owned Property',
    config: {
      route: 'commissionersSaleTranscript/county-owned-property',
      filters: {
        resaleYear: false,
        printDetails: false,
        printOrder: false,
        sortOrder: false,
        sortBy: false,
      },
    },
  }];
  return item;
};

export default {
  queryStringCalc,
};
